import { IrregularOperations } from '../common/enums';
import { formatPriority } from '../components/diversion/diversion-formatters';
import { DiversionPriorityTypeEnum } from '../components/diversion/types';
import { AirportIdDisplayStyleEnum } from '../types/settings';

const thirdPartyFeeds: Map<number, string> = new Map<number, string>([
    [0, 'Unknown'],
    [1, 'Honeywell'],
    [2, 'FedEx'],
    [3, 'UPS'],
    [4, 'Icarus'],
    [5, 'BlueSky'],
    [6, 'Universal'],
    [7, 'TNT'],
    [8, 'ForrestSvc'],
    [9, 'Pace'],
    [10, 'Metron'],
    [11, 'FLYHT'],
    [12, 'Teledyne'],
    [13, 'Latitude'],
    [14, 'WorldAirways'],
    [15, 'FlightExplorer'],
    [16, 'GoldenHour'],
    [17, 'Wingspeed'],
    [18, 'FEPrivateAuth'],
    [19, 'AeroMexico'],
    [20, 'Hawaiian'],
    [21, 'Agilis'],
    [22, 'SITA'],
    [23, 'Northwest'],
    [24, 'Pop3PDI'],
    [25, 'SkyTrax'],
    [26, 'Temsco'],
    [27, 'SCali'],
    [28, 'FlightCell'],
    [29, 'ARINCDirect'],
    [30, 'SatcomDirect'],
    [31, 'AirServices'],
    [32, 'AirChina'],
    [33, 'WIFS3PDI'],
    [34, 'ARINC'],
    [35, 'Honeywell'],
    [36, 'LifeCom'],
    [37, 'SlotList'],
    [38, 'MetronTest'],
    [39, 'MetronDev'],
    [40, 'ChinaSouthern'],
    [41, 'HainanAir'],
    [42, 'CFMU'],
    [43, 'NorthWest-AFM'],
    [44, 'UnivWeather'],
    [45, 'USAirway-AFM'],
    [46, 'FE-ACARS'],
    [47, 'JetBlue'],
    [48, 'CAE-DM'],
    [49, 'United'],
    [50, 'ChinaADCC'],
    [51, 'USAirway-AFM'],
    [52, 'SkyConnect'],
    [53, 'VirginBlue'],
    [54, 'LANAirlines'],
    [55, 'ASDI-AFM'],
    [56, 'Delta-AFM'],
    [57, 'FEManualEntry'],
    [58, 'GuardMobile'],
    [59, 'Avionica'],
    [60, 'Aerolineas-DM'],
    [61, 'FeedVision'],
    [62, 'CAE-MC'],
    [63, 'Republic-DM'],
    [64, 'SkyWest-DM'],
    [65, 'ScheduleData'],
    [66, 'SkyWest-AFM'],
    [67, 'Kenya-DM'],
    [68, 'AirSaudi-AM'],
    [69, 'NipponCargo-AM'],
    [70, 'AlaskaAir-AM'],
    [71, 'ExpressJet-AM'],
    [72, 'AtlanticSE-AM'],
    [73, 'AirCanJazz-AM'],
    [74, ''],
    [75, 'AeroLineas-AM'],
    [76, 'Evergreen-AM'],
    [77, 'SkyWest-AM'],
    [78, 'Kenya-AM'],
    [79, 'LANAirlines-AM'],
    [80, 'Spirit-AM'],
    [81, 'HTTP3PDI'],
    [82, 'Garmin'],
    [83, 'GlobalJet-AM'],
    [84, 'LOT-AM'],
    [85, 'Volaris-AM'],
    [86, 'Ethiopian-AM'],
    [87, 'AmEagle-AFM'],
    [88, 'Ethiopian-DM'],
    [89, 'JetBlue-DM'],
    [90, 'Voyageur'],
    [91, 'Boeing'],
    [92, 'LOT-DM'],
    [93, 'VirginAm-AM'],
    [94, 'ComAir-AM'],
    [95, 'Boeing'],
    [96, 'TripLinhas-AM'],
    [97, 'Namibia-AM'],
    [98, 'TransAero-AM'],
    [99, 'CanJazz-AFM'],
    [100, 'AirBerlin'],
    [101, 'FEInternal'],
    [102, 'ShenzhenAir'],
    [103, 'WestJet-AM'],
    [104, 'MesaAir-AM'],
    [105, 'AirCentre-FPM'],
    [106, 'AirWisconsn-DM'],
    [107, 'SkyTrac'],
    [108, 'Troo'],
    [109, 'AVMax'],
    [110, 'BoeingSimData'],
    [111, 'SpiritAir-DM'],
    [112, 'RyanAir-DM'],
    [113, 'SilverAir-DM'],
    [114, 'Malaysia-FPM'],
    [115, 'Azul-AM'],
    [116, 'WestJet-DM'],
    [117, 'Swiss-AIM'],
    [118, 'JapanAir'],
    [119, 'JapanAir-FPM'],
    [120, 'LOT-FPM'],
    [121, 'Swiss-FPM'],
    [122, 'GLJ-FPM'],
    [123, 'VirginAm-FPM'],
    [124, 'Copa-FPM'],
    [125, 'Malaysia-FPM'],
    [126, 'Airpost-FPM'],
    [127, 'VirginAus-AM'],
    [128, 'VirginAus-FPM'],
    [129, 'Vienna-AM'],
    [130, 'AirTransat-FPM'],
    [131, 'Aeroflot-FPM'],
    [132, 'Aeroflot-AIM'],
    [133, 'Spirit-FPM'],
    [134, 'Turkish-FPM'],
    [135, 'NASA-RA'],
    [136, 'Turkish-AIM'],
    [137, 'United-FPM'],
    [138, 'KunmingAir'],
    [139, 'GOL-FPM'],
    [140, 'GOL-AIM'],
    [141, 'AirSerbia-AM'],
    [142, 'LAN-FPM'],
    [143, 'Airpost-AM'],
    [144, 'JetBlue-AIM/MC'],
    [145, 'AirWis-AM'],
    [146, 'WestJet-FPM'],
    [147, 'FlyDubai-FPM'],
    [148, 'VirginAm-AM'],
    [149, 'COPA-AIM'],
    [150, 'FlyDubai-AIM'],
    [151, 'MCGTE'],
    [152, 'Latam-AIM'],
    [153, 'Endeavor-DM'],
    [154, 'BlueSkyTest'],
    [155, 'VirginAtl-FPM'],
    [156, 'AirChina1'],
    [157, 'NewZealand-DM'],
    [158, 'AirChina-DM'],
    [159, 'NCA-FPM'],
    [160, 'SichuanAir'],
    [161, 'Jet2-FPM'],
    [162, 'JetBlue1-FPM'],
    [163, 'ChinaEast-FPM'],
    [164, 'Alliance'],
    [165, 'Bangkok-FPM'],
    [166, 'SHOUT'],
    [167, 'ThaiAir-FPM'],
    [168, 'DLH'],
    [169, 'ChinaEastern'],
    [170, 'Bangkok-AIM'],
    [171, 'CES-AIS'],
    [172, 'Iberojet-FPM'],
    [173, 'Iberojet-AIS'],
    [174, 'Qantas-OCM'],
    [175, 'FlyHT'],
    [176, 'Endeavor-FPM'],
    [177, 'TST-FPM'],
    [178, 'GOL'],
    [179, 'AirArabia'],
    [180, 'FPM633'],
    [181, 'Akasa-FPM'],
    [182, 'Akasa-AIS'],
    [183, 'AirTransat-OCM'],
    [184, 'Spirit-633'],
    [185, 'Bonza-FPM'],
    [186, 'Bonza-AIS'],
    [187, 'Argentinas-633'],
    [188, 'Iberojet-633'],
    [189, 'Aeromexico-633'],
    [301, 'ChinaEstrn-633'],
    [302, 'AirTransat-633'],
    [303, 'NewZealand-633'],
    [304, 'Frontier-633'],
    [305, 'ARSA-633'],
    [306, 'Copa-633'],
    [307, 'Frontier-OCM'],
    [308, 'Swiss-633'],
    [309, 'CargoJet'],
    [310, 'Piedmont'],
    [311, 'PSA'],
    [312, 'CargoJet'],
    [313, 'GLO-633'],
    [314, 'CargoJet-633'],
    [315, 'Frontier-FPM'],
    [316, 'Solairus'],
    [317, 'Skywest-FPM'],
    [318, 'Piedmont-FPM'],
    [319, 'WIFS-USAF'],
    [320, 'PSA-FPM'],
    [321, 'PDT-OCM'],
    [322, 'PSA-OCM'],
    [323, 'Viva-633'],
    [324, 'VirginAtl-633'],
    [325, 'JapanAir-633'],
    [326, 'SunCtry-633'],
    [327, 'SalamAir-633'],
    [328, 'Jazz-FPM'],
    [999, '']
]);

function formatFeedId(input: number | null | undefined): string {
    if (input == null) {
        return '';
    }

    switch (true) {
        case input >= 200 && input <= 250:
            return 'ASDE-X/ASSC';
        case input === 190:
            return 'ADS-B (PF)';
        case input === 191:
            return 'S-ADS-B (PF)';
        case input === 192:
            return 'ADS-B (FA)';
        case input === 193:
            return 'S-ADS-B (FA-Aireon)';
        case input === 194:
            return 'ADS-B (Spire)';
        case input === 195:
            return 'S-ADS-B (Spire)';
        case input === 196:
            return 'ADS-B (P)';
        case input === 197:
            return 'S-ADS-B (P-Aireon)';
        case input === 198:
            return 'ADS-B (A)';
        case input === 199:
            return 'S-ADS-B (A)';
        case input === 105 || input === 106:
            return 'NZ';
        case input === 999:
            return 'Projected';
        case input >= 100 && input <= 110:
            return 'FAA';
        case input === 1000:
            return 'FE';
        case input > 1000:
            return thirdPartyFeeds.get(input - 1000) ?? '3PDI';
        default:
            return '';
    }
}

function formatIrregularOperations(ops: IrregularOperations | null | undefined) {
    switch (ops) {
        case IrregularOperations.Diversion:
            return 'Diversion';
        case IrregularOperations.ExtraStop:
            return 'Extra stop';
        case IrregularOperations.OverFly:
            return 'Over-fly';
        case IrregularOperations.ReturnToField:
            return 'Return to field';
        case IrregularOperations.ReturnToGate:
            return 'Return to gate';
        default:
            return '';
    }
}

function formatRecoveryPriority(input: number | null | undefined, type: DiversionPriorityTypeEnum) {
    if (input == null) {
        return '';
    }

    return formatPriority(input, type);
}

function formatAirportId(airport: { iata?: string | null; icao?: string | null } | null, style: AirportIdDisplayStyleEnum) {
    if (airport == null) {
        return null;
    }

    switch (style) {
        case AirportIdDisplayStyleEnum.iata:
            return airport.iata;
        case AirportIdDisplayStyleEnum.icao:
            return airport.icao;
        case AirportIdDisplayStyleEnum.iataIcao:
            return joinIfNotNull(airport.iata, airport.icao);
        case AirportIdDisplayStyleEnum.icaoIata:
            return joinIfNotNull(airport.icao, airport.iata);
        default:
            return null;
    }
}

function joinIfNotNull(s1: string | null | undefined, s2: string | null | undefined) {
    if (s1 != undefined && s2 != undefined) {
        return `${s1}/${s2}`;
    }
    if (s1) {
        return s1;
    }

    return s2;
}

export default {
    formatFeedId,
    formatIrregularOperations,
    formatRecoveryPriority,
    formatAirportId
};
